<div class="admin">
    <router-outlet></router-outlet>
</div>
